<template>
  <div>
    <svg
      v-show="collapsed"
      class="svg-inline--fa fa-plus fa-w-12"
      aria-hidden="true"
      focusable="false"
      data-prefix="far"
      data-icon="plus"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
    >
      <path
        fill="currentColor"
        d="M368 224H224V80c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h144v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V288h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
      />
    </svg>
    <svg
      v-show="!collapsed"
      class="svg-inline--fa fa-minus fa-w-12"
      aria-hidden="true"
      focusable="false"
      data-prefix="far"
      data-icon="minus"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
      data-fa-i2svg=""
    >
      <path
        fill="currentColor"
        d="M368 224H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'FacetItemCollapseIcon',
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  }
}
</script>
